export const FULLFILLMENT_REQUEST = "FULLFILLMENT_REQUEST";
export const FULLFILLMENT_SUCCESS = "FULLFILLMENT_SUCCESS";
export const FULLFILLMENT_ERROR = "FULLFILLMENT_ERROR";
export const FULLFILLMENT_RESET = "FULLFILLMENT_RESET";
